import { http } from '../../config/axios'

export default function putOpcaoConsultaLote(opcaoConsultaLote: any): Promise<string> {
  return http
    .put('api/opcaoconsultalote', opcaoConsultaLote)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro putOpcaoConsultaLote', error)
      throw Error(error.response.data)
    })
}
